// src/pages/support/components/DeactivatePlayerModal.jsx
import React from "react";
import Modal from "./Modal";

function DeactivatePlayerModal({ playerData, isDeactivating, error, onClose, onConfirm }) {
  if (!playerData) return null;

  return (
    <Modal title="غیرفعال کردن بازیکن" onClose={onClose}>
      <div className="space-y-4">
        {error && <div className="text-red-400 text-sm">{error}</div>}

        <div
          className="rounded-xl border p-4"
          style={{ borderColor: "rgba(245,158,11,0.5)", backgroundColor: "rgba(245,158,11,0.08)" }}
        >
          <p className="text-gray-200">
            آیا از غیرفعال کردن بازیکن <span className="text-white font-semibold">{playerData.username}</span> مطمئن هستید؟
          </p>
          <p className="text-gray-400 text-sm mt-1">
            این بازیکن در تمام تیم‌ها غیرفعال خواهد شد.
          </p>
        </div>

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-xl text-gray-200 border"
            style={{ borderColor: "rgba(55,65,81,0.6)", backgroundColor: "rgba(17,24,39,0.6)" }}
          >
            انصراف
          </button>
          <button
            onClick={onConfirm}
            disabled={isDeactivating}
            className={`px-4 py-2 rounded-xl text-white ${isDeactivating ? "opacity-70" : ""}`}
            style={{ backgroundColor: "#f59e0b" }}
          >
            {isDeactivating ? "در حال غیرفعال..." : "تأیید غیرفعال‌سازی"}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default DeactivatePlayerModal;